import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patch } from '@truefit/http-utils';
import useCurrentGameId from '@/shared/hooks/useCurrentGameId';
import type { EnrichedSportEvent } from '@c360/types';

interface UpdateCustomEventInput {
  description?: string;
  timestamp?: string;
  payload?: Record<string, any>;
}

interface UpdateCustomEventParams {
  eventId: number;
  data: UpdateCustomEventInput;
}

interface UpdateCustomEventResponse {
  success: boolean;
  event: EnrichedSportEvent;
}

const useUpdateCustomEventMutation = () => {
  const queryClient = useQueryClient();
  const gameId = useCurrentGameId();

  return useMutation({
    mutationFn: async ({ eventId, data }: UpdateCustomEventParams) => {
      const response = await patch<UpdateCustomEventResponse>(
        `/v1.0/games/${gameId}/custom-events/${eventId}`,
        data
      );
      return response.data.event;
    },
    onSuccess: () => {
      // Invalidate queries to refresh the events list
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'CustomEvents']
      });
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'PlayByPlay']
      });
    },
  });
};

export default useUpdateCustomEventMutation;
